import { Checkbox, Col, DatePicker, Form, Icon, Input, Row } from 'antd'
import withKeyValue from '../../../../elements/HOC/WithKeyValue'
import withSort from '../../../../elements/HOC/withSort'
import withSpinning from '../../../../elements/HOC/withSpinning'
import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import CountrySelect from '../../../../elements/Select/Country'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withData from '../../../../elements/Select/withData'
import withSelectFetch from '../../../../elements/Select/withSelectFetch'
import { get } from 'lodash'
import { defaultFormItemLayout, rules } from '../../../../modules/FormItems'
import { dateVal } from '../../../../modules/Utils'
import React, { useState } from 'react'
import { compose } from 'recompose'

const LineStatusType = compose(
  withSelectFetch({ dropdown: 'tracking', name: 'LineStatus' }),
  withSpinning,
  withKeyValue(),
  withSort,
)(CustomSelect)

const TypeSelect = compose(
  withSelectFetch({ dropdown: 'tracking', name: 'LineType' }),
  withSpinning,
  withSort,
)(CustomSelect)

function TrackingLinesForm (props) {
  const { line } = props
  const { getFieldDecorator } = props.form
  const [msgLength, setMsgLength] = useState(get(line, 'messages', ['']).length)

  const { data, fetching, fetchURL } = useFetchURL(
    `https://restcountries.eu/rest/v2/all`,
    undefined,
    undefined,
    undefined,
    false,
  )
  const CountrySelect = compose(
    withSpinning,
    withData({
      data: data,
      fetch: fetchURL,
    }),
    withSort,
  )(CustomSelect)

  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Location">
            {getFieldDecorator('location', {
              initialValue: get(line, 'location'),
              rules: rules.select,
            })(<CountrySelect keyAtr={'name'} valueAtr={'name'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Date">
            {getFieldDecorator('date', {
              initialValue: dateVal(line, 'date'),
              rules: rules.date,
            })(<DatePicker showTime={{ format: 'HH:mm' }} style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="status">
            {getFieldDecorator('status', {
              initialValue: get(line, 'status'),
              rules: rules.select,
            })(<LineStatusType/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Line Type">
            {getFieldDecorator('type', {
              initialValue: get(line, 'type', false),
              rules: rules.select,
            })(<TypeSelect/>)}
          </Form.Item>
        </Col>
        <Col span={12} style={{ align: 'center' }}>
          <Form.Item
            {...defaultFormItemLayout}
            label="Send Notification"
            style={{ fontWeight: 'bold', color: 'red' }}>
            {getFieldDecorator('sendEmail', {
              valuePropName: 'checked',
            })(<Checkbox/>)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <h3>
          Event Messages
          <Icon
            style={{ cursor: 'pointer', fontSize: 18, marginLeft: 10 }}
            type="plus-circle"
            theme="filled"
            onClick={() => setMsgLength(prvG => prvG + 1)}
          />
          {msgLength > 1 && (
            <Icon
              style={{ cursor: 'pointer', fontSize: 18, marginLeft: 10 }}
              type="minus-circle"
              theme="filled"
              onClick={() => setMsgLength(prvG => prvG - 1)}
            />
          )}
        </h3>

        {[...Array(msgLength).keys()].map(i => (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={`Messages Line ${i + 1}`}>
              {getFieldDecorator(`messages.${i}`, {
                initialValue: get(line, `messages.${i}`),
                rules: rules.select,
              })(<Input placeholder={'status'}/>)}
            </Form.Item>
          </Col>
        ))}
      </Row>
    </Form>
  )
}

TrackingLinesForm.propTypes = {}
TrackingLinesForm.defaultProps = {}

export default Form.create()(TrackingLinesForm)
